
import React, { useEffect, useState } from 'react';

const empty = (category) => ({
  name:'', company:'', location:'', position:'', phone:'', email:'',
  dateCalled:'', dnc:false, beltType:'', category, notes:[]
});

export default function LeadForm({ onSave, editing, onCancel, currentCategory }){
  const [lead,setLead]=useState(empty(currentCategory));
  useEffect(()=>{ if(editing) setLead(editing); else setLead(empty(currentCategory)); },[editing,currentCategory]);
  const handle=(k,v)=>setLead(prev=>({...prev,[k]:v}));
  const submit=async(e)=>{
    e.preventDefault();
    if(!lead.name||!lead.company){alert('Name and Company are required.');return;}
    try{
      await onSave(lead);
      setLead(empty(currentCategory));
    }catch(err){alert(err.userMessage||err.message||'Error');}
  };
  const cancel=()=>{ setLead(empty(currentCategory)); onCancel&&onCancel(); };
  return(<form className='card form' onSubmit={submit}>
    <h3>{editing?'Edit Lead':'Add Lead'}</h3>
    <label>Name *</label>
    <input value={lead.name} onChange={e=>handle('name',e.target.value)} />
    <label>Company *</label>
    <input value={lead.company} onChange={e=>handle('company',e.target.value)} />
    <label>Location</label>
    <input value={lead.location||''} onChange={e=>handle('location',e.target.value)} />
    <label>Position</label>
    <input value={lead.position} onChange={e=>handle('position',e.target.value)} />
    <div className='row'>
      <div>
        <label>Phone</label>
        <input value={lead.phone} onChange={e=>handle('phone',e.target.value)} />
      </div>
      <div>
        <label>Email</label>
        <input value={lead.email} onChange={e=>handle('email',e.target.value)} />
      </div>
    </div>
    <label>Date Called</label>
    <input type='date' value={lead.dateCalled? String(lead.dateCalled).split('T')[0]:''}
      onChange={e=>handle('dateCalled', e.target.value || '')} />
    <div className='checkbox'>
      <label className='inline-flex items-center gap-2 cursor-pointer select-none'><input id='dnc' type='checkbox' checked={!!lead.dnc} onChange={e=>handle('dnc',e.target.checked)} /><span className='text-sm text-gray-700'>DNC</span></label>
    </div>
    {currentCategory==='inventory'&&(<>
      <label>Belt Type</label>
      <input value={lead.beltType||''} onChange={e=>handle('beltType',e.target.value)} />
    </>)}
    <div className='form-actions'>
      <button type='submit' className='btn primary'>{editing?'Save':'Add Lead'}</button>
      {editing?<button type='button' className='btn' onClick={cancel}>Cancel</button>:
      <button type='button' className='btn' onClick={()=>setLead(empty(currentCategory))}>Reset</button>}
    </div>
  </form>);
}
